<template>
  <MClinics1View :key="countRefresh"
    @onDataChangedEvent="refreshView"></MClinics1View>
</template>

<script>
// import axios from 'axios'
// import { MyApiClient } from '../myjs/my-api-client.js'
// Bootstrap and jQuery libraries
import 'bootstrap/dist/css/bootstrap.min.css'
import 'jquery/dist/jquery.min.js'
// Datatable Modules
import 'datatables.net-dt/js/dataTables.dataTables'
import 'datatables.net-dt/css/jquery.dataTables.min.css'
// import $ from 'jquery'
// import Swal from 'sweetalert2'
import { inject, ref } from 'vue'

import MClinics1View from './MClinics1View.vue'

export default {
  setup () {
    var globalCorpID = inject('corpID', ref(-1))
    var globalCorpName = inject('corpName', ref(''))
    var globalBranchID = inject('branchID', ref(-1))
    var globalUserID = inject('userID', ref(-1))
    var globalUserName = inject('userName', ref(''))
    var globalUserOfficialName = inject('userOfficialName', ref(''))
    var globalUserPosition = inject('userPosition', ref(''))
    var globalCorpInfo = inject('corpInfo', {})
    return {
      globalCorpID, globalCorpName, globalBranchID, globalUserID, globalUserName, globalUserOfficialName, globalUserPosition, globalCorpInfo
    }
  },
  name: 'ClinicReq',
  components: {
    MClinics1View
  },
  data () {
    return {
      countRefresh: 0
    }
  },
  mounted () {

  },
  methods: {
    refreshView () {
      this.countRefresh++
    }
  }
}
</script>

<style>

</style>
